import { colors } from '../colors'

export const avatar = {
  loadingBgColor: colors.background.light.secondary,
  shadow: '0 0 1px 0  rgba(0, 0, 0, 0.125)',
}
